import { useEffect, useRef, useState } from 'react';
import { SumaryRows } from '../Atc-calculator-constants';
import { ATC_DATA } from '../types';

interface QuarterData {
  percentageToBeDeposited: string;
  taxToBeDeposited: string;
  taxPaid: string;
  taxDueForQuarter: string;
}

interface REGIME_PROPS {
  regime: ATC_DATA;
  totalAdvanceTaxDue: string;
}

const RegimeSummary: React.FC<REGIME_PROPS> = ({
  regime,
  totalAdvanceTaxDue,
}) => {
  const advanceTaxQuarterResults = regime.advanceTaxQuarterResults;
  const periods = Object.keys(advanceTaxQuarterResults).map(
    (key) => advanceTaxQuarterResults[key]?.period
  );

  const tableContainerRef = useRef<HTMLDivElement>(null);
  const [activeDot, setActiveDot] = useState(0);
  const totalDots = 3;

  const handleScroll = () => {
    if (tableContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        tableContainerRef.current;
      const maxScrollLeft = scrollWidth - clientWidth;
      const scrollPercentage = (scrollLeft / maxScrollLeft) * (totalDots - 1);
      setActiveDot(Math.round(scrollPercentage));
    }
  };

  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [totalDots]);

  return (
    <>
      <div className="overflow-x-auto" ref={tableContainerRef}>
        <table className="table-auto border-collapse border border-gray-300 w-full">
          <thead>
            <tr>
              <th className="sticky left-0 z-10 border border-gray-300 px-4 py-2 bg-[#D0E4FE]  text-left">
                Quarter
              </th>
              {periods.map((period, index) => (
                <th
                  key={index}
                  className="border border-gray-300 px-4 py-2  text-left"
                >
                  {period}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="sticky left-0 z-10 border border-gray-300 px-4 py-2 bg-[#D0E4FE] font-semibold">
                Total Advance Tax Due
              </td>
              {periods.map((_, colIndex) => (
                <td key={colIndex} className="border border-gray-300 px-4 py-2">
                  {totalAdvanceTaxDue}
                </td>
              ))}
            </tr>
            {SumaryRows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td className="sticky left-0 z-10 border border-gray-300 bg-[#D0E4FE] font-semibold px-4 py-2">
                  {row.label}
                </td>
                {Object.keys(advanceTaxQuarterResults).map(
                  (quarterKey, colIndex) => {
                    const quarterData = advanceTaxQuarterResults[quarterKey];
                    return (
                      <td
                        key={colIndex}
                        className="border border-gray-300 px-4 py-2"
                      >
                        {quarterData
                          ? quarterData[row.key as keyof QuarterData]
                          : ''}
                      </td>
                    );
                  }
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-4">
        {Array.from({ length: totalDots }).map((_, index) => (
          <div
            key={index}
            className={`hidden sm:block w-2 h-2 rounded-full mx-1 ${
              index === activeDot ? 'bg-[#D0E4FE]' : 'bg-gray-300'
            }`}
          ></div>
        ))}
      </div>
    </>
  );
};

export default RegimeSummary;
